import React, { useEffect } from 'react';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';
import styled from 'styled-components';
import Text from 'crehana-ui/Text';
import { useTranslation } from 'react-i18next';
import { Notification } from 'crehana-ui/Notification';
import Timer from '../Timer/Timer';
import {
  AFTER_PURCHASE_AD_MOUNTED,
  AFTER_PURCHASE_AD_CLICKED,
} from '../../../events';

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  margin-top: 16px;
  .description {
    max-width: 50%;
  }
  @media (max-width: 425px) {
    flex-direction: column;
    margin-top: 8px;
    .description {
      margin-bottom: 8px;
      max-width: unset;
    }
    a {
      margin-top: 12px;
    }
  }
`;

const Title = styled.div`
  @media (max-width: 425px) {
    max-width: 95%;
  }
`;

type propTypes = {
  open: boolean;
  discount: number;
  minimumAmount: number;
  closeNotificationBox: () => void;
  currentPage: string;
  expiredDate: number;
  currencyType: string;
};

const NotificationDiscount = ({ ...props }: propTypes) => {
  const {
    open,
    discount,
    minimumAmount,
    closeNotificationBox,
    currentPage,
    expiredDate,
    currencyType,
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    window.track(AFTER_PURCHASE_AD_MOUNTED, {
      from: '/home/',
      type: 'AD_MOUNTED',
    });
  }, []);

  const removeNotificationUntilNewSession = () => {
    closeNotificationBox();
  };

  return (
    <Notification
      open={open}
      onRequestClose={() => {
        removeNotificationUntilNewSession();
      }}
    >
      <Title className="mb-12">
        <Text type="h4" responsive="sm" color="base-main">
          {t('AD_TITLE1')}
          {discount}
          {t('AD_TITLE2')}
        </Text>
      </Title>
      <DescriptionContainer>
        <div className="flex justify-center">
          <Timer expiredDate={expiredDate} label="vence en" />
        </div>
        {currentPage !== '/cursos-online/' && (
          <a href="/cursos-online/">
            <PrimaryButton
              label={t('AD_BUTTON')}
              className="pr-12 pl-12"
              full
              onClick={() => {
                window.track(AFTER_PURCHASE_AD_CLICKED, {
                  from: '/home/',
                  destination: currentPage,
                  type: `${discount}% discount`,
                });
              }}
            />
          </a>
        )}
      </DescriptionContainer>
      <div className="mt-12 description">
        <Text type="body4" responsive="sm" color="base-main">
          {t('AD_MIN_AMOUNT')} {currencyType} {`${minimumAmount}.00`}.
        </Text>{' '}
        <Text type="body4" responsive="sm" color="gray-dark">
          {t('AD_DESCRIPTION')}
        </Text>
      </div>
    </Notification>
  );
};

export default NotificationDiscount;
